import ipregex from '../../utils/ipRegex.min';

const exactIpRegEx = ipregex(({ exact: true }));

const stripUrlPort = url => {
  const portBeginning = url.indexOf(':');
  if (portBeginning !== -1) {
    return url.substr(0, portBeginning);
  }

  return url;
};

const isIp = (ip, stripPort = false) => exactIpRegEx.test(stripPort ? stripUrlPort(ip) : ip);

export default isIp;
